import type {FieldConfig, GenericFieldHTMLAttributes} from 'formik';
import {useFormikContext, getIn} from 'formik';
import type {ReactElement} from 'react';
import Switch from '@components/Switch';
import type {SwitchProps} from '@interfaces/Switch';

type FullProps = SwitchProps & FieldConfig & GenericFieldHTMLAttributes;

export default function FormSwitch(props: FullProps): ReactElement<FullProps> {
    const finalProps: FullProps = {labelPosition: 'right', disabled: false, ...props};
    const context = useFormikContext();
    return <Switch checked={Boolean(getIn(context.values, props.name))} {...finalProps} />;
}
